import { z } from 'zod'

import { ConversionsApiStatus } from 'common/settings/constants/ConversionsApiStatus'

export const ConversionsApiValueSchema = z.object({
  dataset_id: z.number(),
  status: z.nativeEnum(ConversionsApiStatus),
  is_automated_event_sending_enabled: z.boolean(),
})
